import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IOption } from '@shared/select/option.interface';

// NOTE: F5 этапа 1 - вид ставки НДС, которого нет в стране проекта (UZ - "Льготная"), бэкенд оставляет в rates
// с legacy: true, только если он уже стоит у записей проекта. Новой записи и записи с другой ставкой пункт не показываем;
// у записи, где он выбран, - показываем недоступным (active: false) с пометкой, чтобы поле не стало пустым
// NOTE: F10 этапа 1 - при выключенном НДС минимального режима бэкенд отдает один пункт "Не облагается" (id 3), а у записи
// сохранена другая ставка: показываем ее недоступным пунктом без процента (названия сохраненной ставки в enums нет),
// иначе поле выглядит пустым. Значение записи не меняется
const NOT_TAXED_RATE_ID = 3;

@Pipe({
  name: 'vatRateOptions',
  standalone: true,
})
export class VatRateOptionsPipe implements PipeTransform {
  constructor(private _translate: TranslateService) {}

  transform(rates: IOption[] | null | undefined, current: number | null | undefined): IOption[] {
    const options: IOption[] = (rates ?? []).reduce((options: IOption[], option: IOption) => {
      if (!option.legacy) {
        options.push(option);
      } else if (option.id === current) {
        options.push({
          ...option,
          name: `${option.name} (${this._translate.instant('TAX_RATE_NOT_IN_JURISDICTION')})`,
          active: false,
        });
      }
      return options;
    }, []);
    if (this.isSavedRateHidden(options, current)) {
      options.push({
        id: current as number,
        name: this._translate.instant('TAX_RATE_NOT_APPLIED_VAT_OFF'),
        active: false,
      });
    }
    return options;
  }

  // NOTE: список состоит только из "Не облагается" (НДС выключен), а у записи выбрана другая ставка
  private isSavedRateHidden(options: IOption[], current: number | null | undefined): boolean {
    return (
      current !== null &&
      current !== undefined &&
      current !== NOT_TAXED_RATE_ID &&
      options.length > 0 &&
      options.every(({ id }: IOption) => id === NOT_TAXED_RATE_ID)
    );
  }
}
